import React, { useEffect, useState } from 'react';
import { PrimaryButton } from 'cdk-radial';
import { useTheme } from 'styled-components';
import {
  IAllowedIPRange,
  IAllowedIPRangeUIModel,
} from './IPRestrictionInterface';
import {
  StyledInput,
  StyledTextArea,
  StyledTextButton,
  StyledActionButtonContainer,
  StyledSelectChip,
    SideSheetDetailContainer,SideSheetHeader,SideSheetBodyContainer,
    StyledSheet,StyledCustomScrollbarWrapper
} from './StyledComponents';
import { IPRestrictionSideSheet } from './IPRestrictionInterface';
import { AllowedIpRangeComponent } from './AllowedIpRangeComponent';
import { useTranslation } from 'react-i18next';
import {ApplicationPreviewCard ,WorkflowPreviewCard} from '../Cards/PreviewCard';
import { useAnalytics } from '../../v2/third-party-integration/amplitude';
import { AMPLITUDE_EVENTS } from '../../constants';
import {
  Toast,
  TOAST_POSITIONS,
  TOAST_VISIBILITY_DURATIONS,
  BUTTON_VARIANTS,
  BUTTON_ICON_COLORS,
  IconCancelOutlined,
  IconClose
} from 'cdk-radial';
import { RoundedIconButton } from "../Buttons/IconButton";
import {GlobalTemplate} from './GlobalTemplate';
import {Dialog} from 'cdk-radial';
import { createPortal } from "react-dom";
import { AllowedIPInputWithHelperText } from './AllowedIPInputWithHelperText';
import { MultiSelectDropdownMenu } from '../UnifyAdministration/Notification/Elements/MultiSelectDropdownMenu';
import { useIamUserProfileStore } from '../../Store';

type Positions = {
  top: string;
  bottom: string;
  left: string;
  right: string;
};

type ActionButtonsContainer = {
  children: React.ReactNode;
  position?: string;
  positionProps?: Partial<Positions>;
  background?: string;
  zIndex?: string;
};

const ActionButtonContainer = ({
  children,
  position,
  positionProps,
  background,
  zIndex,
}: ActionButtonsContainer): JSX.Element => {
  return (
    <StyledActionButtonContainer
      positionProps={positionProps}
      position={position}
      background={background}
      zIndex={zIndex}
    >
      {children}
    </StyledActionButtonContainer>
  );
};

function toCamelCase(word:string) {
  return  word && word.length > 2 && word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

const Preview = ({ visible, name, iconColor, iconText, label, isApplication }: any) => {
  return (
    <>
     {visible && <div style={{ marginTop: '20px' }}>
      <div
        style={{
          fontFamily: 'Roboto,sans-serif',
          fontWeight: 400,
          fontSize: '14px',
          marginLeft: '8px',
          marginTop: '5px',
          marginBottom: '5px',
        }}
      >
        {label}
      </div>
      { isApplication && <ApplicationPreviewCard
        key={name}
        name={name}
        iconColor={iconColor || ''}
        iconText={iconText || ''}
      />}
      { !isApplication && <WorkflowPreviewCard
        key={name}
        name={name}
      />}
    </div> }
    </>
  );
};


  const validateIPRange = (beginIP: string, endIP: string): boolean => {
    if (!beginIP || !endIP) return false;
    
    const ipToNumber = (ip: string): number => {
      const parts = ip.split('.').map(Number);
      return (parts[0] << 24) + (parts[1] << 16) + (parts[2] << 8) + parts[3];
    };
    
    try {
      const beginNum = ipToNumber(beginIP);
      const endNum = ipToNumber(endIP);
      return beginNum < endNum;
    } catch {
      return false;
    }
  };

  function checkForDuplicateRanges(
    ipRanges: IAllowedIPRangeUIModel[],
    t: any
  ): { hasDuplicates: boolean; updatedRanges: IAllowedIPRangeUIModel[] } {
    const seen = new Set<string>();
    let hasDuplicates = false;
  
    const updatedRanges = ipRanges.map(range => ({
      ...range,
      hasBeginError: false,
      hasEndError: false
    }));
  
    for (let i = 0; i < updatedRanges.length; i++) {
      const key = `${updatedRanges[i].begin}-${updatedRanges[i].end}`;
      if (seen.has(key)) {
        hasDuplicates = true;
        updatedRanges[i].hasBeginError = true;
        updatedRanges[i].beginErrorMsg = t('dealer-admin.ip-access.label.hasDuplicates') ;
        updatedRanges[i].endErrorMsg = t('dealer-admin.ip-access.label.hasDuplicates');
        updatedRanges[i].hasEndError = true;
        // Also mark the first occurrence
        const firstIndex = updatedRanges.findIndex(
          (r, idx) => idx < i && `${r.begin}-${r.end}` === key
        );
        if (firstIndex !== -1) {
          updatedRanges[firstIndex].hasBeginError = true;
          updatedRanges[firstIndex].hasEndError = true;
        }
      } else {
        seen.add(key);
      }
    }
  
    return { hasDuplicates, updatedRanges };
  }


const IPRestrictionHeader = (props :{ title:string ,onClose : Function}) =>{
  return (<SideSheetHeader>
          <div style={{display:'flex'}}>
              <div style={{marginTop:'8px',marginLeft:'12px'}}>{props.title}</div>
          </div>
            <div>
            <RoundedIconButton
                style={{marginRight:'12px'}}
                dataTestId={"detail-close"}
                darkMode
                icon={<IconClose />}
                onClick={props.onClose}
                text="Close Detail"
            />
            </div> 
        </SideSheetHeader>)
}

export const IPRestrictionSideSheetDetails = ({
  model,
  onSave,
  onCancel,
}: IPRestrictionSideSheet): JSX.Element => {
  const { trackEvent } = useAnalytics();
  const { darkMode } = useTheme();
  const { t } = useTranslation();

  const ipRegex =
    /^((25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?))(,\s*((25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)))*$/;

  const [showToast, setShowToast] = useState(false);
  const [toastType, setToastType] = useState('Error');
  const [ipAddress, setIpAddress] = useState<string>('');
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [warningMessage, setWarningMessage] = useState('');
  const [allowedIPRangeModel, setAllowedIPRangeModel] = useState<IAllowedIPRangeUIModel[]>([]);
  const [selectedValue, setSelectedValue] = useState('') as any;
  const [template, setTemplate] = useState() as any;
  const [options,setOptions] = useState([]);
  const [defaultSelectedValue,setDefaultSelectedValue] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [selectedStores, setSelectedStores] = useState<any[]>([]);
  const iamUserInfo = useIamUserProfileStore((state: any) => state.iamUserInfo);
  const [isSaveInProgress,setIsSaveInProgress] = useState(false);

  const storeOptions = (iamUserInfo?.fullUser?.stores || [])
    .filter((store: any) => store.id !== model.storeId)
    .map((store: any) => ({
      label: `${store.name} - ${store.id}`,
      value: store.id,
    }))
    .sort((a: any, b: any) => a.label.localeCompare(b.label));

  const handleOpen = () => {
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
  };
  

  const handleSelect = (value:any) => { 
    setSelectedValue(value);
    const template = model.availableTemplates?.find((template:any)=> template.id === value);
    setTemplate(template);
   };

  const handleRemove = () => {  
    setSelectedValue(null);
    setTemplate(null);
  }

  useEffect(() => {

    if(model){
    setDefaultSelectedValue(model.templates && model.templates[0]);

    let message = `Your organization has restricted access to ${model.entityName} from this location. Contact your dealership administrator for more information.`;
    setIpAddress(model.allowedIps?.join(',') || '');

    const allowedIpRange = model.allowedIpRange?.map(
      (ipRange: IAllowedIPRange, index: number) => {
        return {
          id: index + 1,
          begin: ipRange.begin,
          end: ipRange.end,
        } as IAllowedIPRangeUIModel;
      }
    ) || [];

    const selectedTemplate = model.templates && model.templates[0];

    const templates = model.availableTemplates?.map((template:any,index:number) =>{
      return {
        id:template.id,
        label: template.name,
        value: template.id
      }
    }) as any || [] as any;

    setOptions(templates);

    if(selectedTemplate){
      setSelectedValue(selectedTemplate);
    }

    handleSelect(selectedTemplate)
    
    setAllowedIPRangeModel(allowedIpRange);
    setWarningMessage(model.message && model.message.length > 0 ? model.message : message);
  }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [model]);

  const validateIPAddresses = (ipAddressString: string): { isValid: boolean; error: string } => {
    if (!ipAddressString || ipAddressString.trim().length === 0) {
      return { isValid: true, error: '' };
    }

    const ipList = ipAddressString
      .split(',')
      .map((ip: string) => ip.trim())
      .filter((ip: string) => ip.length > 0);

    // Check for duplicates
    const uniqueIPs = new Set();
    let hasDuplicates = false;
    
    for (const ip of ipList) {
      if (uniqueIPs.has(ip)) {
        hasDuplicates = true;
        break;
      }
      uniqueIPs.add(ip);
    }

    if (hasDuplicates) {
      return { 
        isValid: false, 
        error: t('dealer-admin.ip-access.label.hasDuplicates') as string 
      };
    }

    // Validate IP format
    if (!ipRegex.test(ipAddressString)) {
      return { 
        isValid: false, 
        error: t('dealer-admin.ip-access.label.invalidIp') as string 
      };
    }

    return { isValid: true, error: '' };
  };

  const validateIPRanges = (): { isValid: boolean } => {
    if (!allowedIPRangeModel || allowedIPRangeModel.length === 0) {
      return { isValid: true };
    }
  
    const singleIpRegex = /^(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)$/;
  
    let isValid = true;
    const updatedModel = allowedIPRangeModel.map(range => {
      let hasBeginError = false;
      let hasEndError = false;
      let beginErrorMsg = '';
      let endErrorMsg = '';
  
      if (!range.begin && !range.end) {
        hasBeginError = true;
        hasEndError = true;
        isValid = false;
        beginErrorMsg = t('dealer-admin.ip-access.label.rangeIP');
        endErrorMsg = t('dealer-admin.ip-access.label.rangeIP');
      } else if (!range.begin || !range.end) {
        if (!range.begin) hasBeginError = true;
        if (!range.end) hasEndError = true;
        isValid = false;
        beginErrorMsg = t('dealer-admin.ip-access.label.enterIP');
        endErrorMsg = t('dealer-admin.ip-access.label.enterIP');
      } else {
        if (!singleIpRegex.test(range.begin)) {
          hasBeginError = true;
          isValid = false;
          beginErrorMsg = t('dealer-admin.ip-access.label.invalidIp');
        }
        if (!singleIpRegex.test(range.end)) {
          hasEndError = true;
          isValid = false;
          endErrorMsg = t('dealer-admin.ip-access.label.invalidIp');
        }
  
        if (!hasBeginError && !hasEndError && !validateIPRange(range.begin, range.end)) {
          hasBeginError = true;
          hasEndError = true;
          isValid = false;
          beginErrorMsg = t('dealer-admin.ip-access.label.invalidIpRange');
          endErrorMsg = t('dealer-admin.ip-access.label.invalidIpRange');
        }
      }
  
      return {
        ...range,
        hasBeginError,
        hasEndError,
        beginErrorMsg,
        endErrorMsg
      };
    });
  
    if (!isValid) {
      setAllowedIPRangeModel(updatedModel);
      return { isValid };
    }
  
    // Check for duplicate ranges (only if no field errors)
    const { hasDuplicates, updatedRanges } = checkForDuplicateRanges(updatedModel,t);
    if (hasDuplicates) {
      setAllowedIPRangeModel(updatedRanges);
      return {
        isValid: false,
      };
    }
  
    // No errors: reset any previous error flags
    const cleanedModel = updatedModel.map(r => ({
      ...r,
      hasBeginError: false,
      hasEndError: false
    }));
  
    setAllowedIPRangeModel(cleanedModel);
    return { isValid: true, };
  };


  const handleIPAddressChange = (event: any) => {
    const newIpAddress = event.target.value;
    setShowToast(false);
    setIpAddress(newIpAddress);
    // Clear any previous errors when user types
    setHasError(false);
    setErrorMessage('');
  };

  const handleWarningMessageChange = (event: any) => {
    setWarningMessage(event.target.value);
  };

  const confirmSave = () =>{


    // Clear previous errors
    setHasError(false);
    setErrorMessage('');

    // Validate IP addresses
    const ipValidation = validateIPAddresses(ipAddress);
    
    // Validate IP ranges
    const rangeValidation = validateIPRanges();

    // Show validation errors
    if (!ipValidation.isValid) {
      setHasError(true)
      setErrorMessage(ipValidation.error);
      return;
    }

    if (!rangeValidation.isValid) {
      return;
    }

    if(model.entityId === "UNIFY"){
      handleOpen();
    }else{
      handleSave();
    }

  }

  const handleSave = () => {

    setIsSaveInProgress(true);
    const templates = [];

    if(selectedValue){
      templates.push(selectedValue);
    }

    // Prepare data for save
    const range = allowedIPRangeModel
      ?.filter((range: any) => range.begin && range.end) // Only include complete ranges
      ?.map((range: IAllowedIPRangeUIModel) => ({
        begin: range.begin,
        end: range.end,
      }));

    const modelObj = {
      entityId: model.entityId,
      entityType: model.entityType,
      allowedIps: ipAddress ? ipAddress.split(',').map((ip: string) => ip.trim()) : [],
      allowedIpRange: range,
      message: warningMessage,
      templates:templates,
    } as any;

    onSave(modelObj);
    if (selectedStores.length > 0) {
      for (const store of selectedStores) {
        if (store.value !== model.storeId) {
          const additionalModel = {
            ...modelObj,
            storeId: store.value,
          };
          onSave(additionalModel);
        }
      }
    }
    trackEvent(AMPLITUDE_EVENTS.DEALER_ADMINISTRATION, { Action: 'IP Access Save' });
  };

  const handleCancel = () => {
    onCancel();
  };

  const resetToastState = () => {
    setErrorMessage('');
    setToastType('');
    setShowToast(false);
  };

  return (
    <StyledSheet>
      <SideSheetDetailContainer data-testid="ip-restriction-detail-template" >
       <IPRestrictionHeader 
            title = {t('dealer-admin.ip-access.detail.title')}
            onClose={handleCancel}/>

    <StyledCustomScrollbarWrapper>
      <SideSheetBodyContainer>
      <StyledInput
        dataTestId={`application`}
        id={`application-name`}
        inputDivider="left"
        label={
          model.entityType === 'application'
            ? t('dealer-admin.ip-access.label.application')
            : t('dealer-admin.ip-access.label.workflow')
        }
        name={'application'}
        onChange={() => {}}
        value={model.entityName || ''}
        isDisabled={true}
      />

      <>
        <style>{`
          div[style*="z-index: 1000"] {
            z-index: 10000 !important;
          }
        `}</style>
        <div >
          <MultiSelectDropdownMenu
            options={storeOptions}
            name="additionalStores"
            onSelect={(selection: any[]) => setSelectedStores(selection)}
            value={selectedStores}
            label="Stores"
            placeholder="Select stores"
            isDisabled={false}
          />
        </div>
      </>

      <div style={{ marginTop: '10px' }}>
        {
        defaultSelectedValue && 
          <StyledSelectChip 
            dataTestId="template_chip"
            defaultLabel="Apply Template" 
            defaultSelectedValue={defaultSelectedValue}
            onRemove={handleRemove} 
            onSelect={handleSelect} 
            options={options} >
            </StyledSelectChip>
      }
      {
        !defaultSelectedValue && 
          <StyledSelectChip 
            dataTestId="template_chip"
            defaultLabel="Apply Template" 
            onRemove={handleRemove} 
            onSelect={handleSelect} 
            options={options} >
            </StyledSelectChip>
      }
      </div>

      {
      template && 
      <div style={{paddingBlockEnd:'10px',borderBottom:'2px gray solid'}}>
        <div style={{padding:'5px'}}>
         <GlobalTemplate template={template}></GlobalTemplate>
         </div>
      </div>
      }

      <div style={{marginBottom:'10px',borderBottom:'2px gray solid'}}>
        <div style={{marginBottom:'10px'}}>

          <div style={{ marginTop: '10px' }}>
            <div
              style={{
                fontFamily: 'Roboto,sans-serif',
                fontWeight: 400,
                fontSize: '14px',
                marginLeft: '8px',
                marginTop: '5px',
                marginBottom: '5px',
              }}
            >
              {t('dealer-admin.ip-access.label.allowedIPAddressManual')}
            </div>
            <AllowedIPInputWithHelperText helperLabel={t('dealer-admin.ip-access.label.publicIpInfo')}>
            <StyledTextArea
              dataTestId={`ip-address-input`}
              errorMessage={errorMessage}
              id={`ip-address-input`}
              inputDivider="left"
              label={t('dealer-admin.ip-access.label.ipAddress')}
              name={'ipaddress'}
              onChange={handleIPAddressChange}
              placeholder={t('dealer-admin.ip-access.label.ipAddressPlaceHolder')}
              value={ipAddress || ''}
              maxLength={500}
              enableCustomValidation
              hasError={hasError}
            />
            </AllowedIPInputWithHelperText>
          </div>

          <div>
            
            <AllowedIpRangeComponent
              allowedIPRange={allowedIPRangeModel}
              setAllowedIPRangeModel={setAllowedIPRangeModel}
              isDisabled={false}
              label={t('dealer-admin.ip-access.label.allowedIPRangeManual')}
            />
          </div>
        </div>
      </div>

      {model.entityId !== 'UNIFY' && (
        <Preview
          visible={ipAddress !== '' || allowedIPRangeModel?.length > 0}
          name={model.entityName}
          iconColor={model.iconColor || ''}
          iconText={model.iconText || ''}
          label={toCamelCase(model.entityType) + " " + t('dealer-admin.ip-access.label.preview')}
          isApplication={model.entityType === 'application'}
        />
      )}

      <div style={{ marginTop: '20px' }}>
        <StyledTextArea
          dataTestId={`message-input`}
          id={`message-input`}
          inputDivider="left"
          label={t('dealer-admin.ip-access.label.warningMessage')}
          name={'message'}
          onChange={handleWarningMessageChange}
          placeholder={"Enter warning message"}
          value={warningMessage || ''}
          hasCharacterCount
          maxLength={300}
          enableCustomValidation
        />
      </div>

      <ActionButtonContainer
        position="sticky"
        zIndex="999"
        positionProps={{ bottom: '0px' }}
        background={
          darkMode
            ? 'linear-gradient(black, transparent)'
            : 'linear-gradient(white, transparent)'
        }
      >
        <div>
          <StyledTextButton
            dataTestId="cancel-side-sheet-button"
            id="id-cancel-side-sheet-button"
            iconColor="primary"
            onClick={handleCancel}
            text={t('dealer-admin.ip-access.label.cancel')}
          />
          <PrimaryButton
            isDisabled={isSaveInProgress}
            dataTestId="save-side-sheet-button"
            id="id-save-side-sheet-button"
            iconColor="primary"
            onClick={confirmSave}
            text={t('dealer-admin.ip-access.label.save')}
          />
        </div>

        {showToast && (
        <Toast
          id="ip-access-toast"
          datatestid="ip-access-toast"
          position={TOAST_POSITIONS.FIXED}
          style={{
            marginTop: '70px',
            zIndex: 1003,
          }}
          variant={toastType === 'Error' ? 'negative' : 'positive'}
          visibilityDuration={TOAST_VISIBILITY_DURATIONS.SIX_SECONDS}
          onVisibilityDurationEnd={() => {
            resetToastState();
          }}
          actions={[
            {
              onClick: () => {
                resetToastState();
              },
              variant: BUTTON_VARIANTS.ICON,
              icon: <IconCancelOutlined />,
              iconColor: BUTTON_ICON_COLORS.GRAY,
              text: '',
            },
          ]}
          content={errorMessage}
        />
      )}

      </ActionButtonContainer>
      </SideSheetBodyContainer>
    </StyledCustomScrollbarWrapper>

    </SideSheetDetailContainer>

        {isOpen &&
        createPortal(
          <Dialog
            id="ip-confirmation-dialog"
            isOpen={isOpen}
            onClose={handleClose}
            title={t('dealer-admin.ip-access.label.confirmation')}
            disableFocusTrap={true}
            style={{ zIndex: 5000 }} // number, not string, is fine too
            buttonsProps={[{
                dataTestId: 'ip-confirmation-dialog-cancel',
                id: 'id-ip-confirmation-dialog-cancel',
                onClick: handleClose,
                text: t('dealer-admin.ip-access.label.cancel'),
                variant: BUTTON_VARIANTS.TEXT
              }, {
                dataTestId: 'ip-confirmation-dialog-save',
                id: 'id-ip-confirmation-dialog-save',
                onClick: handleSave,
                text:t('dealer-admin.ip-access.label.save'),
                variant: BUTTON_VARIANTS.PRIMARY
              }]}
          >
            {t('dealer-admin.ip-access.detail.confirmationMessage')}
          </Dialog>,
          document.body
        )}


    </StyledSheet>
  );
};
